import { Translation } from "@shared/types/translation";
import { useLocale } from "@translations/locale-context";
import { Show } from "@uxf/core/components/show";
import Image from "next/legacy/image";
import React from "react";

const INSTITUTIONS: {
    src: string;
    height: number;
    width: number;
    name: string;
    description: Translation;
    member: string | null;
}[] = [
    {
        src: "/static/landing-pages/ux-audit-partners/baymard.svg",
        height: 50,
        width: 200,
        name: "Baymard Institute",
        description: {
            cs: "Přes 100\u00a0000\u00a0h uživatelských výzkumů. Dlouhodobé studie napříč top 100 největšími e-shopy z\u00a0USA i\u00a0Evropy",
            en: "Over 100,000 hours of user research. Long-term studies across the top 100 largest e-shops from the USA and Europe.",
        },
        member: "Baymard Pro member",
    },
    {
        src: "/static/landing-pages/ux-audit-partners/conversion.svg",
        height: 50,
        width: 82.5,
        name: "ConversionXL",
        description: {
            cs: "Optimalizace konverzí A/B\u00a0testy, digitální psychologie a\u00a0přesvědčování",
            en: "Conversion optimization using A/B tests, digital psychology and persuasion.",
        },
        member: null,
    },
    {
        src: "/static/landing-pages/ux-audit-partners/goodui.svg",
        height: 50,
        width: 80,
        name: "GoodUI",
        description: {
            cs: "Monitoring testů velkých hráčů a\u00a0UX vzorce, user inteface",
            en: "Monitoring tests of big players and UX patterns, user interface.",
        },
        member: "Member",
    },
    {
        src: "/static/landing-pages/ux-audit-partners/nn.svg",
        height: 25,
        width: 224,
        name: "nngroup",
        description: {
            cs: "Více než 2000 publikací o\u00a0výzkumu uživatelského rozhraní, psychologie a\u00a0metodických frameworků",
            en: "More than 2000 publications on user interface research, psychology and methodological frameworks.",
        },
        member: null,
    },
];

const ContentCs = () => (
    <>
        <h2 className="pb-4 text-h2Mobile font-bold text-uxfViolet sm:text-medium xl:text-h5">
            Vzděláváme se&nbsp;od nejlepších <span className="text-uxfOrange">z&nbsp;celého světa</span>
        </h2>
        <p className="text-small1 text-uxfMuted75 sm:text-body">
            Jsme členy významných světových výzkumných institucí a&nbsp;projektů
        </p>
    </>
);

const ContentEn = () => (
    <>
        <h2 className="pb-4 text-h2Mobile font-bold text-uxfViolet sm:text-medium xl:text-h5">
            We learn from the best from <span className="text-uxfOrange">around the world</span>
        </h2>
        <p className="text-small1 text-uxfMuted75 sm:text-body">
            We are members of important global research institutions and projects
        </p>
    </>
);

export const InstitutionCard = () => {
    const locale: "cs" | "en" = useLocale();
    return (
        <>
            {INSTITUTIONS.map((institution) => (
                <div key={institution.name} className="text-small1 sm:text-body">
                    <div className="flex h-[50px] items-center">
                        <Image width={institution.width} height={institution.height} src={institution.src} alt="logo" />
                    </div>
                    <div className="space-y-2 md:space-y-5 md:pt-8">
                        <p className="font-bold text-uxfVioletDark">{institution.name}</p>
                        <p className="text-uxfMuted75">{institution.description[locale]}</p>
                        <Show when={!!institution.member}>
                            <p className="pt-2 text-uxfMuted75 md:pt-5">{institution.member}</p>
                        </Show>
                    </div>
                </div>
            ))}
        </>
    );
};

export const EducationSection = () => {
    const locale: "cs" | "en" = useLocale();
    return (
        <div className="container p-5 pb-14 md:px-0">
            <div className="pb-12">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
            <div className="grid gap-10 md:grid-cols-4">
                <InstitutionCard />
            </div>
        </div>
    );
};
